import { GetServerSideProps } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import CommandersPage from '../commanders'

export const getServerSideProps: GetServerSideProps = async ({ query, req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/cards/${query.slug}.json`, req.headers)

export default CommandersPage
